import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import React from 'react'
import { StateInitials,State_City_Zip_Mapper } from '../../../services/Model/Participant'

import OutcomeTextItem from '../../FormTemplates/CustomOutcomeTextItem/OutcomeTextItem'

interface LocationDetailsProps extends WithStyles<typeof styles> {
	required?: boolean
	jobPlacementEmployerAddress1: string | null
	jobPlacementEmployerAddress2: string | null
	jobPlacementEmployerCity: string | null
	jobPlacementEmployerState: string
	jobPlacementEmployerZipcode: string | null
	onEmployerAddress1Change: (e: React.ChangeEvent<HTMLInputElement>) => void
	onEmployerAddress2Change: (e: React.ChangeEvent<HTMLInputElement>) => void
	onEmployerCityChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onEmployerStateChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	onEmployerZipcodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const LocationDetails: React.FC<LocationDetailsProps> = (props: LocationDetailsProps) => {
	const {
		classes,
		jobPlacementEmployerAddress1,
		jobPlacementEmployerAddress2,
		jobPlacementEmployerCity,
		jobPlacementEmployerState,
		jobPlacementEmployerZipcode,
		onEmployerAddress1Change,
		onEmployerAddress2Change,
		onEmployerCityChange,
		onEmployerStateChange,
		onEmployerZipcodeChange,
		required,
	} = props
  console.log(`Location Details required=${required}`)
  // If there is already some value for state, city and zip add it to the array of State_City_Zip_Mapper for dropdown
  const State_City_Zip_Mapper_LOCAL = [...State_City_Zip_Mapper]
  debugger
  console.log(`Location details jobPlacementEmployerState=${jobPlacementEmployerState}`)
  console.log(`Location details jobPlacementEmployerCity=${jobPlacementEmployerCity}`)
  console.log(`Location details jobPlacementEmployerZipcode=${jobPlacementEmployerZipcode}`)
  if(jobPlacementEmployerState?.length>0 && jobPlacementEmployerCity?.length>0 && jobPlacementEmployerZipcode?.length>0){
    const ele = State_City_Zip_Mapper_LOCAL.find((x) => x?.state?.toLowerCase()?.trim() === jobPlacementEmployerState?.toLowerCase()?.trim() && (x?.city?.toLowerCase()?.trim() === jobPlacementEmployerCity?.toLowerCase()?.trim() && x?.zip?.trim() === jobPlacementEmployerZipcode?.trim()))
    if(!ele && jobPlacementEmployerState?.toUpperCase()?.trim() == 'RI'){
      console.log(`Location details Adding location`)
      State_City_Zip_Mapper_LOCAL.push({
        state: jobPlacementEmployerState,
        city: jobPlacementEmployerCity,
        zip: jobPlacementEmployerZipcode
      })
      console.log(`Location details Added ${JSON.stringify({
        state: jobPlacementEmployerState,
        city: jobPlacementEmployerCity,
        zip: jobPlacementEmployerZipcode
      })}`)
    }
    else{
      console.log(`Location details ele=${JSON.stringify(ele)}`)  
    }
  }

	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				Address&#58;{ props.required === true && (<span className={classes.requiredField} >*</span> ) }
			</Grid>

			<Grid item={true} xs={12} sm={5}>
				<OutcomeTextItem
					required={required}
					placeholder="Address1"
					prop="jobPlacementEmployerAddress1"
					value={jobPlacementEmployerAddress1 || ''}
					onInputChange={onEmployerAddress1Change}
				/>
			</Grid>
			<Grid item={true} xs={12} sm={4}>
				<OutcomeTextItem
					required={false}
					placeholder="Address2"
					prop="jobPlacementEmployerAddress2"
					value={jobPlacementEmployerAddress2 || ''}
					onInputChange={onEmployerAddress2Change}
				/>
			</Grid>
			<Grid item={true} xs={12} md={3}/>
			<Grid item={true} xs={12} sm={3}>
				<TextField
					name="jobPlacementEmployerState"
					select={true}
					required={required}
					className={classes.dropdown}
					value={jobPlacementEmployerState}
					onChange={onEmployerStateChange}
					SelectProps={{
						native: true,
						MenuProps: {
							className: classes.input,
						},
					}}
					InputProps={{
						inputProps: {
							className: classes.select,
						},
					}}
					label="State"
					margin="dense"
					variant="outlined"
				>
					{!jobPlacementEmployerState && <option value="" />}
					{StateInitials.map((option: string) => (
						<option key={option} value={option}>
							{option || ''}
						</option>
					))}
				</TextField>
			</Grid>
      <Grid item={true} xs={12} sm={3}>
        {(State_City_Zip_Mapper_LOCAL.some((x) => x.state === jobPlacementEmployerState) ? (<TextField
					name="jobPlacementEmployerCity"
					select={true}
					required={required}
					className={classes.dropdown}
					value={jobPlacementEmployerCity || ''}
					onChange={onEmployerCityChange}
					SelectProps={{
						native: true,
						MenuProps: {
							className: classes.input,
						},
					}}
					InputProps={{
						inputProps: {
							className: classes.select,
						},
					}}
					label="City"
					margin="dense"
					variant="outlined"
				>
					{<option value="" />}
          {
            State_City_Zip_Mapper_LOCAL.filter((x) =>{ 
              if(!jobPlacementEmployerState) return true
              if(jobPlacementEmployerCity) return true
              return (x.state === jobPlacementEmployerState && (x.zip === jobPlacementEmployerZipcode || !jobPlacementEmployerZipcode))
            }).reduce((agg,e)=>{
              if(agg.indexOf(e.city) === -1){
                agg.push(e.city)
              }
              return agg
            },[]).map((city: string) => {
              return (
                <option key={city} value={city}>
                  {city || ''}
                </option>
              )
            })
          }
				</TextField>) : (<OutcomeTextItem
					required={required}
					placeholder="City"
					prop="jobPlacementEmployerCity"
					value={jobPlacementEmployerCity || ''}
					onInputChange={onEmployerCityChange}
				/>)) }
			</Grid>
			<Grid item={true} xs={12} sm={3}>
        {(State_City_Zip_Mapper_LOCAL.some((x) => x.state === jobPlacementEmployerState) ? (<TextField
					name="jobPlacementEmployerZipcode"
					select={true}
					required={required}
					className={classes.dropdown}
					value={jobPlacementEmployerZipcode || ''}
					onChange={onEmployerZipcodeChange}
					SelectProps={{
						native: true,
						MenuProps: {
							className: classes.input,
						},
					}}
					InputProps={{
						inputProps: {
							className: classes.select,
						},
					}}
					label="Zipcode"
					margin="dense"
					variant="outlined"
				>
					{<option value="" />}
          {
            State_City_Zip_Mapper_LOCAL.filter((x) =>{ 
              if(!jobPlacementEmployerCity || !State_City_Zip_Mapper.some(ele=>ele?.city.toLowerCase()?.trim()==jobPlacementEmployerCity?.toLowerCase()?.trim())) return true
              return (x.city?.toLowerCase()?.trim() === jobPlacementEmployerCity?.toLowerCase()?.trim() && x.state?.toLowerCase()?.trim() === jobPlacementEmployerState?.toLowerCase()?.trim())
            }).reduce((agg,e)=>{
              if(agg.indexOf(e.zip) === -1){
                agg.push(e.zip)
              }
              return agg
            },[]).map((zip: string) => {
              return (
                <option key={zip} value={zip}>
                  {zip || ''}
                </option>
              )
            })
          }
				</TextField>) : (<OutcomeTextItem
					required={required}
					placeholder="Zipcode"
					prop="jobPlacementEmployerZipcode"
					value={jobPlacementEmployerZipcode || ''}
					onInputChange={onEmployerZipcodeChange}
				/>)) }
			</Grid>
      
      <Grid item={true} xs={12} md={3}/>

      <Grid item={true} xs={12} sm={9} md={9} >

      {State_City_Zip_Mapper_LOCAL.some((x) => x.state === jobPlacementEmployerState) ? <span className={classes.tip}><b>Tip:</b> To help ensure accurate and consistent data entry, select a ZIP code first to automatically filter matching city names, or select a city name first to filter ZIP codes that match your selection. This will minimize errors and help us maintain clean and reliable data records.</span>:""}

      </Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		dropdown: { display: 'flex', flex: 1 },
		dropdownLabel: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		input: {},
		select: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
		},
    requiredField:{
      color:'red'
    },
    tip:{
      color:'red',
      fontStyle: 'italic'
    }
	})

export default withStyles(styles)(LocationDetails)
